<ng-container *transloco="let t; read: 'header'">
  <div class="container d-flex align-items-center justify-content-between py-2 h-60">
    <div class="d-flex justify-content-between align-self-end logo-menu">
      <shared-logo></shared-logo>
      <button class="btn d-xl-none" type="button" (click)="openEnd(content)">
        <i class="fa-solid fa-bars fs-5"></i>
      </button>
    </div>
    <!-- Desktop View -->
    <div class="hearight d-none d-xl-flex align-self-end">
      <nav *ngIf="!userToken" class="nav fw-medium d-flex align-items-center flex-nowrap">
        <a class="nav-link px-3 active" routerLink="/dashboard" href="/dashboard">{{t('home')}}</a>
        <!-- <a class="nav-link px-3 " routerLink="/services" href="/services">{{t('services')}}</a>
        <a class="nav-link px-3" routerLink="/agencies" href="/agencies">{{t('certifiedAgencies')}}</a>
        <a class="nav-link px-3" routerLink="/about" href="/about">{{t('aboutMoawen')}}</a>
        <a class="nav-link px-3" routerLink="/news" href="/news">{{t('newsEvents')}}</a> -->
        <a class="nav-link px-3 " routerLink="/coming-soon" href="/coming-soon">{{t('services')}}</a>
        <a class="nav-link px-3" routerLink="/coming-soon" href="/coming-soon">{{t('certifiedAgencies')}}</a>
        <a class="nav-link px-3" routerLink="/coming-soon" href="/coming-soon">{{t('aboutMoawen')}}</a>
        <a class="nav-link px-3" routerLink="/coming-soon" href="/coming-soon">{{t('newsEvents')}}</a>
        <a class="nav-link px-3" routerLink="/faq" href="/faq">{{t('faq')}}</a>
      </nav>
      <div class="d-flex align-items-center gap-2 ms-4 header-btns">
        <div class="btn-group">
          <a href="#" class="btn btn btn-light btn-sm px-2 font-plus">A+</a>
          <a href="#" class="btn btn btn-light btn-sm px-2 font-minus">A-</a>
        </div>
        <button class="btn btn btn-light btn-sm px-2 eye-btn">
          <i class="fa-regular fa-eye fa-sm"></i>
          <!-- <fa-icon [icon]="['fas', 'eye']"></fa-icon> -->
        </button>
        <button class="header-btn btn btn btn-light btn-sm px-2 font-regular lang-btn" (click)="onLangChange(currentLang)">
          <span>{{ currentLang === 'en' ? 'عربي' : 'English' }}</span>
        </button>
        <button *ngIf="!userToken" class="header-btn btn btn btn-light btn-sm px-3 font-regular" [routerLink]="['/account/login']"
          routerLinkActive="router-link-active">{{t('logIn')}}</button>
        <div ngbDropdown *ngIf="userToken">
          <button class="btn btn-light btn-sm px-3 font-regular user-btn" id="dropdownBasic1" ngbDropdownToggle>
            <i class="fa-regular fa-user"></i>
            <i class="fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem [routerLink]="['/profile/contactInfo']" >{{t('profile')}}</button>
            <button ngbDropdownItem (click)="logout()" >{{t('logout')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Mobile View -->
    <ng-template #content let-offcanvas>
      <div class="hearight">
        <nav class="nav fw-medium flex-column p-3">
          <a class="nav-link px-3 active" routerLink="/dashboard" href="/dashboard">{{t('home')}}</a>
          <!-- <a class="nav-link px-3 " routerLink="/services" href="/services">{{t('services')}}</a>
          <a class="nav-link px-3" routerLink="/agencies" href="/agencies">{{t('certifiedAgencies')}}</a>
          <a class="nav-link px-3" routerLink="/about" href="/about">{{t('aboutMoawen')}}</a>
          <a class="nav-link px-3" routerLink="/news" href="/news">{{t('newsEvents')}}</a> -->
          <a class="nav-link px-3 " routerLink="/coming-soon" href="/coming-soon">{{t('services')}}</a>
          <a class="nav-link px-3" routerLink="/coming-soon" href="/coming-soon">{{t('certifiedAgencies')}}</a>
          <a class="nav-link px-3" routerLink="/coming-soon" href="/coming-soon">{{t('aboutMoawen')}}</a>
          <a class="nav-link px-3" routerLink="/coming-soon" href="/coming-soon">{{t('newsEvents')}}</a>
          <a class="nav-link px-3" routerLink="/faq" href="/faq">{{t('faq')}}</a>
        </nav>
        <div class="d-flex align-items-center gap-2 ms-4 header-btns">
          <div class="btn-group">
            <a href="#" class="btn btn btn-light btn-sm px-2">A+</a>
            <a href="#" class="btn btn btn-light btn-sm px-2">A-</a>
          </div>
          <button class="btn btn btn-light btn-sm px-2">
            <i class="fa-regular fa-eye"></i>
            <!-- <fa-icon [icon]="['fas', 'eye']"></fa-icon> -->
          </button>
          <button class="btn btn btn-light btn-sm px-2 font-regular" (click)="onLangChange(currentLang)"> {{currentLang
            === 'en' ? 'عربي' : 'English'}}</button>
          <button class="btn btn btn-light btn-sm px-3 font-regular" [routerLink]="['/account/login']"
            routerLinkActive="router-link-active">{{t('logIn')}}</button>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
